import { readArray, readBoolean, readNumber, readString } from "./mapperUtils.js";

export type CmtsMasterOptionVm = Record<string, unknown> & {
  id: string;
  code: string;
  label: string;
  name: string;
  description: string;
  active: boolean;
  group?: string | undefined;
  masterType?: string | undefined;
  sortOrder?: number | undefined;
  raw?: unknown | undefined;
};
export type CmtsMasterSchemaVm = { masterType: string; fields: readonly { name: string; label: string; dataType: string; required: boolean; lookupRoute?: string | undefined }[] };

function asRecord(dto: unknown): Record<string, unknown> {
  return dto && typeof dto === "object" && !Array.isArray(dto) ? dto as Record<string, unknown> : {};
}

export function mapMasterOption(dto: unknown): CmtsMasterOptionVm {
  const row = asRecord(dto);
  const code = readString(dto, ["code", "id", "value"], "");
  const label = readString(dto, ["label", "name", "displayName", "schema", "policy", "jobName", "code"], "Unnamed");
  const group = readString(dto, ["group", "masterType", "groupCode"], "");
  return {
    ...row,
    id: readString(dto, ["id", "code", "value"], code),
    code,
    label,
    name: readString(dto, ["name", "label", "displayName", "schema", "policy", "jobName", "code"], label),
    description: readString(dto, ["description", "remarks", "summary"], ""),
    active: readBoolean(dto, ["active", "enabled", "isActive"], true),
    group,
    masterType: readString(dto, ["masterType", "group"], group),
    sortOrder: readNumber(dto, ["sortOrder"], 9999),
    raw: dto,
  };
}
export function mapMasterSchema(dto: unknown, masterType: string): CmtsMasterSchemaVm { return { masterType: readString(dto, ["masterType"], masterType), fields: readArray(dto, ["fields", "schema"], (f) => ({ name: readString(f, ["name", "fieldName"], "unknown"), label: readString(f, ["label", "displayName", "name"], "Unknown"), dataType: readString(f, ["dataType", "type"], "text"), required: readBoolean(f, ["required"], false), lookupRoute: readString(f, ["lookupRoute"], "") })) }; }
